const identity = k => k;

/**
 * HtmlIterator iterates html strings, passing html segments
 * to one callback and plain-text segments to another callback
 */
export class HtmlIterator {
	/**
	 * Create a new iterator with the given string processors
	 * @param {Function} htmlProcessor  Function that will process each HTML chunk
	 * @param {Function} textProcessor  Function that will process each text chunk
	 */
	constructor(htmlProcessor = null, textProcessor = null) {
		this.htmlProcessor = htmlProcessor || identity;
		this.textProcessor = textProcessor || identity;
	}

	/**
	 * Iterate the given html string running the htmlProcessor and textProcessor once for each segment
	 * @param {String} html
	 * @return {undefined}
	 */
	forEach(html) {
		let parts = html.split(/(<[^>]+>)/);
		for (let i = 0; i < parts.length; i++) {
			if (i % 2 === 0) {
				this.textProcessor(parts[i]);
			} else {
				let close = parts[i].slice(1, 2) == '/';
				let open = !close;
				this.htmlProcessor(parts[i], { open, close });
			}
		}
	}

	/**
	 * Update the given html string by transforming each segment with the htmlProcessor or textProcessor
	 * @param {String} html
	 * @return {String}
	 */
	map(html) {
		let mapped = '';
		let parts = html.split(/(<[^>]+>)/);
		for (let i = 0; i < parts.length; i++) {
			if (i % 2 === 0) {
				mapped += this.textProcessor(parts[i]);
			} else {
				let close = parts[i].slice(1, 2) == '/';
				let open = !close;
				mapped += this.htmlProcessor(parts[i], { open, close });
			}
		}
		return mapped;
	}
}
